/* Liste de favoris « maison » : enregistrée dans le navigateur du visiteur (localStorage), sans compte ni application. */
(function () {
  var KEY = 'tk-wish';
  var cache = {};

  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* stockage indisponible */ } }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) {
    var l = read(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    write(l.slice(0, 60));
    refresh();
    document.dispatchEvent(new CustomEvent('tk:wish'));
  }
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function product(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw new Error('absent'); return r.json(); }).catch(function () { return null; });
    return cache[h];
  }

  /* cœurs et compteur */
  function refresh() {
    var l = read();
    [].forEach.call(document.querySelectorAll('[data-tk-wish]'), function (el) {
      var on = l.indexOf(el.getAttribute('data-tk-wish')) > -1;
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      el.setAttribute('aria-label', on ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
    [].forEach.call(document.querySelectorAll('[data-tk-wish-count]'), function (c) { if (c.textContent !== String(l.length)) c.textContent = l.length; c.hidden = l.length === 0; });
  }

  /* panneau de l'en-tête */
  function renderPanel() {
    var box = document.querySelector('[data-tk-wish-panel]');
    if (!box) return;
    var l = read();
    if (!l.length) {
      box.innerHTML = '<p>Vous n’avez pas encore de favoris. Touchez le cœur d’un produit pour l’enregistrer ici.</p><a class="tk-notif__cta" href="/collections/all">Voir les tables basses</a>';
      return;
    }
    box.innerHTML = '<p class="tk-wl__loading">Chargement…</p>';
    Promise.all(l.slice(0, 4).map(product)).then(function (items) {
      var html = '<ul class="tk-wl__list">';
      items.forEach(function (p, i) {
        if (!p) return;
        html += '<li><a href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2')) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="tk-wl__ph"></span>') +
          '<span class="tk-wl__t">' + esc(p.title) + '</span><span class="tk-wl__p">' + money(p.price) + '</span></a>' +
          '<button type="button" class="tk-wl__rm" data-tk-wish="' + esc(l[i]) + '" aria-label="Retirer des favoris">×</button></li>';
      });
      html += '</ul>';
      if (l.length > 4) html += '<p class="tk-wl__more">+ ' + (l.length - 4) + ' autre' + (l.length - 4 > 1 ? 's' : '') + '</p>';
      html += '<a class="tk-notif__cta" href="/pages/favoris">Voir tous mes favoris (' + l.length + ')</a>';
      box.innerHTML = html;
      refresh();
    });
  }

  /* page « Mes favoris » */
  function renderPage() {
    var host = document.querySelector('[data-tk-wish-page]');
    if (!host) return;
    var l = read();
    var empty = host.querySelector('[data-tk-wish-empty]'), grid = host.querySelector('[data-tk-wish-grid]');
    if (!l.length) { empty.hidden = false; grid.innerHTML = ''; return; }
    empty.hidden = true;
    Promise.all(l.map(product)).then(function (items) {
      var html = '';
      items.forEach(function (p, i) {
        if (!p) return;
        html += '<div class="tk-wp__card"><a class="tk-wp__img" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2')) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="tk-wp__rm" data-tk-wish="' + esc(l[i]) + '" aria-label="Retirer des favoris">×</button>' +
          '<a class="tk-wp__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><p class="tk-wp__p">' + money(p.price) + '</p></div>';
      });
      grid.innerHTML = html;
      refresh();
    });
  }

  /* clics : cœurs (cartes, fiche produit, retraits) */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-tk-wish]');
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    toggle(el.getAttribute('data-tk-wish'));
  }, true);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.tk-heart[data-tk-wish]')) { e.preventDefault(); toggle(e.target.getAttribute('data-tk-wish')); }
  });
  document.addEventListener('tk:wish', function () { renderPanel(); renderPage(); });
  document.addEventListener('click', function (e) { if (e.target.closest('.tk-fav [data-tk-notif-btn]')) renderPanel(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { refresh(); renderPanel(); renderPage(); } });
  window.addEventListener('pageshow', refresh);

  /* cartes ajoutees apres coup (filtres, « Voir plus ») */
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (list) {
      /* on ne reagit qu'a l'ajout de nouveaux coeurs (et jamais a nos propres mises a jour) */
      var added = list.some(function (m) { return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('[data-tk-wish]') || n.querySelector('[data-tk-wish]')); }); });
      if (!added || pending) return;
      pending = true;
      setTimeout(function () { pending = false; refresh(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  refresh(); renderPanel(); renderPage();
})();
